import { FC } from 'react';
import { Typography } from '@mui/material';

export const JobTemplateHelpContent: FC = () => {
  return (
    <>
      <Typography variant="body1" paragraph>
        Job templates are <strong>reusable job descriptions</strong> that define the role, compensation, benefits, and
        requirements for a position.
      </Typography>

      <Typography variant="body1" paragraph>
        When you create a job posting, you can select an existing template from your rooftop or create a new one. Using
        templates saves time when posting similar positions across multiple ads.
      </Typography>

      <Typography variant="body1">
        Any changes made to a job template will automatically update all active job postings using that template. This
        makes it easy to keep your listings accurate and consistent.
      </Typography>
    </>
  );
};

export default JobTemplateHelpContent;
